/* eslint-disable no-restricted-syntax */
import cheerio from 'cheerio'

const findContentWithImgTag = contentArray => {
  for (const item of contentArray) {
    if (item?.Content?.includes('<img')) {
      return item.Content
    }
  }
  return null // or any other value to indicate no content with <img> tag was found
}

const findContentWithOnlyPTag = contentArray => {
  for (const item of contentArray) {
    const content = item?.Content?.trim()
    const hasPTag = content?.startsWith('<p') && content.endsWith('</p>')
    const hasNoOtherTags = !content?.includes('<img')

    if (hasPTag && hasNoOtherTags) {
      return item.Content
    }
  }
  return null // or any other value to indicate no content with <p> tag only was found
}

export const extractCardHeroImageUrl = data => {
  if (data) {
    const htmlContent = findContentWithImgTag(data)

    if (typeof htmlContent === 'string') {
      const $ = cheerio.load(htmlContent, null, false)

      const imageUrl = $('img').attr('src')

      return imageUrl
    }
    return ''
  }
}

export const extractCardHeroDescription = data => {
  if (data) {
    const htmlContent = findContentWithOnlyPTag(data)

    if (typeof htmlContent === 'string') {
      const $ = cheerio.load(htmlContent, null, false)

      const paragraphTexts: any = []
      $('p').each((_, element) => {
        paragraphTexts.push($(element).text().trim())
      })

      return paragraphTexts
    }

    return ''
  }
}
